import { render, staticRenderFns } from "./approval_invitation.vue?vue&type=template&id=4b998bad&scoped=true"
import script from "./approval_invitation.vue?vue&type=script&lang=js"
export * from "./approval_invitation.vue?vue&type=script&lang=js"
import style0 from "./approval_invitation.vue?vue&type=style&index=0&id=4b998bad&prod&lang=scss&scoped=true"
import style1 from "./approval_invitation.vue?vue&type=style&index=1&id=4b998bad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b998bad",
  null
  
)

export default component.exports